// src/lib/punchAccess.js
// 出退勤（打刻・勤怠）画面を表示しない社員コードの定義と判定ユーティリティ。
// ※ 対象を増減したい場合は HIDDEN_PUNCH_MEMBER_IDS を編集してください。
//    memberId / employeeId のどちらに一致しても非表示にします（大文字小文字・前後空白は無視）。

export const HIDDEN_PUNCH_MEMBER_IDS = ["S000", "S001"];

function norm(v) {
  return (v ?? "").toString().trim().toUpperCase();
}

const HIDDEN_SET = HIDDEN_PUNCH_MEMBER_IDS.map(norm);

/** 指定の社員コード（memberId / employeeId のいずれか）が打刻非表示対象か */
export function isPunchHiddenForId(...ids) {
  return ids.some((id) => id && HIDDEN_SET.includes(norm(id)));
}

/** ログイン中の社員（localStorage "user"）が打刻非表示対象か */
export function isPunchHiddenForCurrentUser() {
  try {
    const u = JSON.parse(localStorage.getItem("user") || "null");
    return isPunchHiddenForId(u?.memberId, u?.employeeId);
  } catch {
    return false;
  }
}
